export const TAB_TITLE_PREFIX = 'ix.lab | ';
